import React, {useCallback} from 'react';
import {Form} from '@/_application/core/components/ui/forms/form';
import {
    AuthenticationFaq,
    LoginForm,
    OtpChannelSelector,
    useAuth,
    OtpVerification,
    RegisterForm,
} from '@kidslabs/module-auth';

import styles from './otp.module.css';

export const OtpLogin = () => {
    const {currentStep} = useAuth();

    const renderContent = useCallback(() => {
        switch (currentStep) {
            case 'EnterPhoneNumber':
                return <LoginForm FormComponent={Form} />;
            case 'SelectChannel':
                return <OtpChannelSelector FormComponent={Form} />;
            case 'VerifyOtp':
                return <OtpVerification />;
            case 'Register':
                return <RegisterForm FormComponent={Form} />;
            case 'Faq':
                return <AuthenticationFaq />;
        }
    }, [currentStep]);

    return <div className={styles.container}>{renderContent()}</div>;
};
